import * as React from 'react';
import { ConfigProvider, Divider, Drawer, Empty, Modal, Progress, Row, Spin, Table, } from 'antd';

import { isGranted, L } from '../../../../lib/abpUtility';
import { SmallDashOutlined, LoadingOutlined, RightCircleTwoTone, ApiTwoTone, BuildTwoTone, ContactsTwoTone, DashboardTwoTone, DollarTwoTone, IdcardTwoTone, LayoutTwoTone, LockTwoTone, MessageTwoTone, ProjectTwoTone, ReconciliationTwoTone, ScheduleTwoTone, ShopTwoTone, TagsTwoTone } from '@ant-design/icons';
 
import { appRouters } from '../../../Router/router.config';
import ModuleSelectCard from '../../Views/Cards/moduleSelectCard'; 


export interface IModuleChooserProps {

    loading: boolean;
    isMobile: boolean; 
    primaryColor: string;
    secondaryColor: string;
    dataTableImage: any;
    dataTableText: string;
    search_Mentions: any;
    search_Hashtags: any;
    visible: boolean;  

    handleSearch: (value: string) => void;
    onCreate: (values: any) => void;
    onCancel: () => void;
}

export interface IModuleChooserBaseState {
    itemCreateDrawerOpen: boolean;
    stateCreateDrawerOpen: boolean;
    optionCreateDrawerOpen: boolean;

    defaultItemImage: string;
    itemProfileID: number;
    defaultStateImage: string;
    stateProfileID: number;
    prefix: any;

    tableSize: any;
    searchMargin: any;
    formSize: any;

    moduleData: any[];
}

class ModuleChooser extends React.Component<IModuleChooserProps, IModuleChooserBaseState> {


    state =
        {
            formSize: '',
            searchSize: '230px',
            tableSize: '100%',
            searchMargin: '15px',
            prefix: '@',
            itemCreateDrawerOpen: false,
            stateCreateDrawerOpen: false,
            optionCreateDrawerOpen: false,
            defaultItemImage: '',
            itemProfileID: 0,
            defaultStateImage: '',
            stateProfileID: 0,

            moduleData: []
        };

    async componentDidMount() {

        if (window.innerWidth >= 550) {

            if (window.innerWidth >= 800) {
                this.setState({
                    searchMargin: '0'
                });
            }
            else {
                this.setState({
                    searchMargin: '0'
                });
            }

            this.setState({

                tableSize: (window.innerWidth * 0.85).toString() + 'px',
                formSize: (window.innerWidth * 0.85).toString() + 'px',

            });
        }
        else {
            this.setState({

                tableSize: (window.innerWidth * 0.80).toString() + 'px',
                formSize: (window.innerWidth * 0.80).toString() + 'px',
                searchMargin: '0'
            });
        }

        this.setState({moduleData: []});
        
        var newModules: any[] = []; 
        await appRouters.filter((item: any) => !item.isLayout && item.showInMenu)
        .map((route: any, index: number) => {
          if (route.permission && !isGranted(route.permission)) return null;
          if(route.id === -1) return null;
 
          return newModules.push({
            id: route.id,
            name: route.name,
            title: route.title,
            icon: route.icon,
            showInMenu: route.showInMenu,
            component: route.component,
          })
        })

        this.setState({moduleData: newModules});

        window.addEventListener('resize', this.handleResize);
    }

    handleResize = () => {


        if (window.innerWidth >= 550) {

            if (window.innerWidth >= 800) {
                this.setState({
                    searchMargin: '0'
                });
            }
            else {
                this.setState({
                    searchMargin: '0'
                });
            }

            this.setState({

                tableSize: (window.innerWidth * 0.85).toString() + 'px',
                formSize: (window.innerWidth * 0.85).toString() + 'px',
            });
        }
        else {
            this.setState({

                tableSize: (window.innerWidth * 0.80).toString() + 'px',
                formSize: (window.innerWidth * 0.80).toString() + 'px',
                searchMargin: '0'
            });
        }

    }
 

    handleCancel = () => { 
        this.props.onCancel();
    }


    handleSearch(e: any) {

        if (e.slice(-1) === ' ') {
            this.props.handleSearch(e.replace('@', '').replace('#', '').slice(0, -1));
        }
        else {
            this.props.handleSearch(e.replace('@', '').replace('#', ''));
        }
    };
 

    onSearch = (_: any, prefix: any) => {
        this.setState({ prefix: prefix });
    };


    render() {
 
        const templateChooserColumns = [
            {
                title: L('Modules'), dataIndex: 'moduleChooser', key: 'moduleChooser', style: { backgroundColor: 'black' },
                render: (text: string, item: any) => {
                    return {
                        props: {
                            style: { paddingTop: '2px', paddingBottom: '10px', }
                        },
                        children: <div className="font-face-gm">
                            <ModuleSelectCard
                                tinyReports={[]}
                                defaultIcon={<div>
                                    {
                                      item.icon === 'dashboard' ? (<DashboardTwoTone twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)
              
                                        : item.icon === 'people' ? (<ContactsTwoTone twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)
              
                                          : item.icon === 'teams' ? (<BuildTwoTone twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)
              
                                            : item.icon === 'inventory' ? (<TagsTwoTone twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)
              
                                              : item.icon === 'workOrder' ? (<ReconciliationTwoTone twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)
              
                                                : item.icon === 'scheduling' ? (<ScheduleTwoTone twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)
              
                                                  : item.icon === 'message' ? (<MessageTwoTone twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)
              
                                                    : item.icon === 'reports' ? (<ProjectTwoTone twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)
              
                                                      : item.icon === 'integrations' ? (<ApiTwoTone twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)
              
                                                        : item.icon === 'payments' ? (<DollarTwoTone twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)
              
                                                          : item.icon === 'layout' ? (<LayoutTwoTone twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)
              
                                                            : item.icon === 'user' ? (<IdcardTwoTone twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)
              
                                                              : item.icon === 'role' ? (<LockTwoTone twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)
              
                                                                : item.icon === 'tenant' ? (<ShopTwoTone twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)
              
                                                                  : <RightCircleTwoTone twoToneColor={[this.props.primaryColor, '#f1f2f5']} />}
              
                                  </div> }
                                id={item.id}
                                primaryColor={this.props.primaryColor}
                                secondaryColor={this.props.secondaryColor}
                                title={item.name}
                                subTitle={item.name}
                                cardSelect={() => this.props.onCreate(item.id)} />
                        </div>
                    };
                }
            },
        ];

        const { visible, isMobile } = this.props; 
  
        return (

            <div className="font-face-gm">

                <div>
                    <Modal
                     closable={this.props.isMobile === true ? true : false}
                        visible={isMobile === false ? (visible === true ? true : false) : false}
                        cancelText={L('Cancel')}
                        onCancel={this.handleCancel}
                        footer={null}
                        title={null}>

                        <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '3em', marginBottom: '0px' }} >
                            {L('Select Type')}
                        </Divider>
                        <Row style={{ marginBottom: '18px' }}>
                            <Progress
                                strokeColor={{
                                    from: this.props.secondaryColor,
                                    to: this.props.primaryColor,
                                }}
                                showInfo={false}
                                percent={100}
                                status="normal"
                                size={'small'}
                            />
                        </Row>
                         
                        <div style={{
                            margin: 'auto', float: 'none', width: this.state.tableSize,
                            maxWidth: '400px',
                        }}>

                            <ConfigProvider renderEmpty={() =>
                                <Empty

                                    image={
                                        this.props.loading === true ?
                                            (<SmallDashOutlined />) :

                                            (this.props.dataTableImage)}
                                    imageStyle={{
                                        height: 60,
                                    }}
                                    description={
                                        <span>
                                            {this.props.dataTableText}
                                        </span>
                                    }
                                />}>


                                <Table
                                    //rowKey={record => record.id.toString()}\
                                    style={{ backgroundColor: 'transparent',  }}
                                    size={'small'}
                                    showHeader={false}
                                    bordered={false}
                                    columns={templateChooserColumns}
                                    pagination={{ pageSize: 10, total: this.state.moduleData === undefined ? 0 : this.state.moduleData.length, defaultCurrent: 1 }}
                                    loading={this.props.loading === true ? { indicator: <Spin indicator={<LoadingOutlined style={{ fontSize: 24, color: this.props.primaryColor }} spin />} /> } : false}
                                    dataSource={this.state.moduleData === undefined ? [] : this.state.moduleData}

                                />





                            </ConfigProvider>

                        </div>


                    </Modal>
                </div>

                <div>
                    <Drawer
                        onClose={this.handleCancel}
                        closeIcon={false}
                        closable={this.props.isMobile === true ? true : false}
                        visible={isMobile === true ? (visible === true ? true : false) : false}

                        width={isMobile === true ? (window.innerWidth * 0.9) : 420}  >
                        <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '2.3em', marginBottom: '0px', }} >
                            {L('Select Type')}
                        </Divider>
                        <Row style={{ marginBottom: '10px' }}>
                            <Progress
                                strokeColor={{
                                    from: this.props.secondaryColor,
                                    to: this.props.primaryColor,
                                }}
                                showInfo={false}
                                percent={100}
                                status="normal"
                                size={'small'}
                            />
                        </Row>
 

                        <div style={{
                            margin: 'auto', float: 'none', width: this.state.tableSize,
                            maxWidth: '290px',
                        }}>

                            <ConfigProvider renderEmpty={() =>
                                <Empty

                                    image={
                                        this.props.loading === true ?
                                            (<SmallDashOutlined />) :

                                            (this.props.dataTableImage)}
                                    imageStyle={{
                                        height: 60,
                                    }}
                                    description={
                                        <span>
                                            {this.props.dataTableText}
                                        </span>
                                    }
                                />}>

                                <Table
                                    //rowKey={record => record.id.toString()}\
                                    style={{ backgroundColor: 'transparent' }}
                                    size={'small'}
                                    showHeader={false}
                                    bordered={false}
                                    columns={templateChooserColumns}
                                    pagination={{ pageSize: 10, total: this.state.moduleData === undefined ? 0 : this.state.moduleData.length, defaultCurrent: 1 }}
                                    loading={this.props.loading === true ? { indicator: <Spin indicator={<LoadingOutlined style={{ fontSize: 24, color: this.props.primaryColor }} spin />} /> } : false}
                                    dataSource={this.state.moduleData === undefined ? [] : this.state.moduleData}

                                />


                            </ConfigProvider>

                        </div>





                    </Drawer>
                </div>

                

            </div>
        );
    }
}

export default ModuleChooser;
